/**
 *
 * Copyright 2007
 *
 * Paulius Uza
 * http://www.uza.lt
 *
 * Dan Florio
 * http://www.polygeek.com
 *
 * Project website:
 * http://code.google.com/p/custom-context-menu/
 *
 * --
 * RightClick for Flash Player.
 * Version 0.6.2
 *
 */

var RightClick = {
	/**
	 *  Constructor
	 */
	init: function (container, object) {
		RightClick.FlashObjectID = object;
		RightClick.FlashContainerID = container;
		if(window.addEventListener){
//			 window.addEventListener("mousedown", this.onGeckoMouseDown, true);
//			 window.addEventListener("mouseup", this.onGeckoMouseUp, true);
			 window.addEventListener("mousewheel", this.onGeckoMouseWheel, false);
			 window.addEventListener("DOMMouseScroll", this.onGeckoMouseWheel, false);
//			 window.addEventListener("mouseout", this.onGeckoMouseOut, false);
		} else {
			var viewer = document.getElementById(RightClick.FlashContainerID);

//			viewer.onmouseup = RightClick.onIEMouseUp;
//			viewer.onmousemove = RightClick.onIEMouseMove;
			document.oncontextmenu = function(){ if(window.event.srcElement.id == RightClick.FlashObjectID) { return false; } else { RightClick.Cache = "nan"; }}
//			viewer.onmousedown = RightClick.onIEMouseDown;
			viewer.onmousewheel = RightClick.onIEMouseWheel;
//			viewer.onmouseleave = RightClick.onIEMouseLeave;
		}
		this.Cache = RightClick.FlashObjectID;
	},

	/**
	 *  Destructor
	 */
	cleanup: function() {
		if (RightClick.FlashObjectID) {
			if (window.addEventListener) {
//				window.removeEventListener("mousedown", this.onGeckoMouseDown, true);
//				window.removeEventListener("mouseup", this.onGeckoMouseUp, true);
				window.removeEventListener("mousewheel", this.onGeckoMouseWheel, false);
				window.removeEventListener("DOMMouseScroll", this.onGeckoMouseWheel, false);
			} else {
				var viewer = document.getElementById(RightClick.FlashContainerID);
//				viewer.onmouseup = null;
//				viewer.onmousemove = null;
//				viewer.onmousedown = null;
				viewer.onmousewheel = null;
			}
		}
	},

	/**
	 * GECKO / WEBKIT event overkill
	 * @param {Object} eventObject
	 */
	killEvents: function(eventObject) {
		if(eventObject) {
			if (eventObject.stopPropagation) eventObject.stopPropagation();
			if (eventObject.preventDefault) eventObject.preventDefault();
			if (eventObject.preventCapture) eventObject.preventCapture();
	   		if (eventObject.preventBubble) eventObject.preventBubble();
		}
	},
	/**
	 * GECKO / WEBKIT call right click
	 * @param {Object} ev
	 */
	onGeckoMouseDown: function(ev) {
	    if (ev.button != 0) {
			RightClick.killEvents(ev);

			if(ev.target.id == RightClick.FlashObjectID) {
		    		RightClick.call(1, 0, 0);
			}
		}
	},

	onGeckoMouseUp: function(ev) {
	    if (ev.button != 0) {
			RightClick.killEvents(ev);

			if(ev.target.id == RightClick.FlashObjectID) {
		    		RightClick.call(0, 0, 0);
			}
		}
	},

	onGeckoMouseWheel: function(ev) {
			if (ev.target.id == RightClick.FlashObjectID) {
				RightClick.killEvents(ev);

				var o=0;
				if(ev.wheelDelta) {
					o=ev.wheelDelta/120;
					if(window.opera) o= -o;
				} else if(ev.detail) {
					o= -ev.detail;
				}
				if (ev.preventDefault)
					ev.preventDefault();
		    		RightClick.call(2, 0, o);
			}
	},

	onGeckoMouseOut: function(ev) {
		if(ev.target.id == RightClick.FlashObjectID) {
			RightClick.call(4, 0, 0);
		}
	},

	/**
	 * IE call right click
	 * @param {Object} ev
	 */
	onIEMouseDown: function() {
	  	if (event.button > 1) {
			if(window.event.srcElement.id == RightClick.FlashObjectID &&
			   RightClick.Cache == RightClick.FlashObjectID) {
				var e = window.event.srcElement;

				RightClick.call(1, 0, 0);
			}
			document.getElementById(RightClick.FlashContainerID).setCapture();
			if(window.event.srcElement.id)
				RightClick.Cache = window.event.srcElement.id;
		}
	},

	onIEMouseMove: function(e) {
		if(window.event.srcElement.id == RightClick.FlashObjectID && RightClick.Cache == RightClick.FlashObjectID) {
			var e;
			if (!e)
				e = window.event;
			var flash = document.getElementById(RightClick.FlashObjectID);
			var x = e.offsetX - flash.offsetLeft;
			var y = e.offsetY - flash.offsetTop;

			RightClick.call(3, x, y);
		}
	},

	onIEMouseWheel: function(ev) {

		if (!ev)
			ev = window.event;

		if (ev.srcElement.id == RightClick.FlashObjectID) {

			var o=0;
			if(ev.wheelDelta) {
				o=ev.wheelDelta/120;
				if(window.opera) o= -o;
			} else if(ev.detail) {
				o= -ev.detail;
			}
			if (ev.preventDefault)
				ev.preventDefault();
			RightClick.call(2, 0, o);
			return false;
		}
	},

	onIEMouseLeave: function(ev) {

		if (!ev)
			ev = window.event;

		if (ev.srcElement.id == RightClick.FlashObjectID) {
			RightClick.call(4, 0, 0);
		}
	},

	onIEMouseUp: function() {
		document.getElementById(RightClick.FlashContainerID).releaseCapture();

	  	if (event.button > 1) {
			if(window.event.srcElement.id == RightClick.FlashObjectID && RightClick.Cache == RightClick.FlashObjectID) {
				var e = window.event.srcElement;

				RightClick.call(0, 0, 0);
			}
		}
	},
	/**
	 * Main call to Flash External Interface
	 */
	call: function(type, x, y) {
		var el = document.getElementById(RightClick.FlashObjectID);
		if (el) {
			el.rightClick(type, x, y);
		}
	}
}
